import { useState, useEffect, useRef } from 'react'

interface PageDescriptionProps {
    subtitle: string
    detail: string
    storageKey: string
}

export function PageDescription({ subtitle, detail, storageKey }: PageDescriptionProps) {
    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLSpanElement>(null)

    useEffect(() => {
        if (!open) return
        function handle(e: MouseEvent) {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
        }
        document.addEventListener('mousedown', handle)
        return () => document.removeEventListener('mousedown', handle)
    }, [open])

    void storageKey

    return (
        <span ref={ref} className="relative inline-flex items-center">
            <span className="ml-3 text-xs text-slate-500">{subtitle}</span>
            <button
                onClick={() => setOpen(v => !v)}
                title="About this page"
                className="ml-1.5 text-slate-600 hover:text-slate-400 transition-colors"
            >
                <svg className="h-3 w-3" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm-.75-8.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0zm.75 1.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75z" />
                </svg>
            </button>
            {open && (
                <div className="absolute top-full left-0 mt-2 z-50 w-72 bg-slate-800 border border-slate-700 rounded-xl p-3.5 text-xs text-slate-300 shadow-xl leading-relaxed">
                    {detail}
                </div>
            )}
        </span>
    )
}
